import React from "react";
import { Navigate } from "react-router";
import { Auth } from "@aws-amplify/auth";

import analytics from "fond/analytics";

import { stopImpersonating } from "../impersonate";

/**
 * When rendered, signs the user out and redirects the user
 * to the /signin route.
 */
const SignOut: React.FC = () => {
  stopImpersonating();
  Auth.signOut();
  analytics.track("Signed out");
  analytics.reset();
  sessionStorage.clear();
  return <Navigate to="/signin" />;
};

export default SignOut;
